import React from 'react'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartData,
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { brandColors } from '@/pages/communal/statistics/components/common/const'
import { UseOfStatus } from '@/pages/communal/statistics/components/common/data'
import { Translates } from '@/services/repository/i18n'

ChartJS.register(ArcElement, Tooltip, Legend)

interface UseOfStatusChartProps {
  status: UseOfStatus
  chartTitle: string
  translationsKey: string
  translates: Translates
}

export const UseOfStatusChart: React.FC<UseOfStatusChartProps> = ({
  status, chartTitle, translationsKey, translates
}) => {
  const percentActive = (status.activeTime - status.onFireTime) / status.totalTime * 100
  const percentOnFire = status.onFireTime / status.totalTime * 100
  const percentUnused = Math.max(0, 100 - percentActive - percentOnFire)
  const data: ChartData<'doughnut'> = {
    labels: [
      translates.for(`${translationsKey}.active`),
      translates.for(`${translationsKey}.fire`),
      translates.for(`${translationsKey}.unused`),
    ],
    datasets: [
      {
        data: [
          percentActive,
          percentOnFire,
          percentUnused
        ],
        backgroundColor: [
          brandColors.normal,
          brandColors.good,
          brandColors.unused,
        ],
        borderWidth: 0
      }
    ]
  }

  return (
    <Doughnut
      data={data}
      options={{
        responsive: true,
        plugins: {
          legend: { position: 'bottom' },
          title: { display: true, text: chartTitle },
        }
      }}
    />
  )
}